import Vue from 'vue'

window.vueBus = new Vue()

// eslint-disable-next-line no-undef
export default vueBus
